import { render, staticRenderFns } from "./ServicesReportDashboard.vue?vue&type=template&id=2a6d623e&scoped=true"
import script from "./ServicesReportDashboard.vue?vue&type=script&lang=js"
export * from "./ServicesReportDashboard.vue?vue&type=script&lang=js"
import style0 from "./ServicesReportDashboard.vue?vue&type=style&index=0&id=2a6d623e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d623e",
  null
  
)

export default component.exports